export type SiteLanguage = 'en' | 'fr';

export const DEFAULT_SITE_LANGUAGE: SiteLanguage = 'fr';
export const SITE_LANGUAGE_COOKIE = 'site-language';
export const SITE_LANGUAGE_STORAGE_KEY = 'site-language';

export function normalizeSiteLanguage(value?: string | null): SiteLanguage {
  if (value === 'en') return 'en';
  if (value === 'fr') return 'fr';
  return DEFAULT_SITE_LANGUAGE;
}
